// localStorage persistence helpers for ProductionOrder

export const savingTotalSalePrice = (price) => {
  localStorage.setItem("totalSalePrice", price);
};

export const savingUpdateCartTotals = (itemsCount, qtyCount, subtotal) => {
  localStorage.setItem("totalItems", itemsCount);
  localStorage.setItem("totalQty", qtyCount);
  localStorage.setItem("subtotal", subtotal);
};

export const savingSearchedProductsData = (products) => {
  localStorage.setItem("searchedProductsData", JSON.stringify(products));
};

export const savingIsStockModal = (flag) => {
  localStorage.setItem("isStockModal", flag);
};

export const savingDisableFlag = (flag) => {
  localStorage.setItem("disableSearch", flag);
};

export const savingSelectedProduct = (product) => {
  localStorage.setItem("selectedProduct", JSON.stringify(product));
};

export const savingFormattedDate = (date) => {
  localStorage.setItem("formattedDate", date);
};

export const savingSelectedProductSalePrice = (price) => {
  localStorage.setItem("selectedProductSalePrice", price);
};

export const savingPricingMethod = (method) => {
  localStorage.setItem("pricingMethod", method);
};

export const savingOtherChargesData = (data) => {
  localStorage.setItem("otherChargesData", JSON.stringify(data));
};

export const savingRemarks = (remarks) => {
  localStorage.setItem("remarks", remarks);
};

export const savingQuantityInput = (input) => {
  localStorage.setItem("quantityInputValue", input);
};

export const savingTareWeight = (weight) => {
  localStorage.setItem("tareWeight", weight);
};

export const savingTotalWeight = (weight) => {
  localStorage.setItem("totalWeight", weight);
};

export const savingExpiryDate = (date) => {
  localStorage.setItem("expiryDate", date);
};

export const savingCopies = (value) => {
  localStorage.setItem("copies", value);
};

export const removeLocalStorageData = () => {
  const keysToRemove = [
    "selectedProduct",
    "formattedDate",
    "selectedProductSalePrice",
    "pricingMethod",
    "otherChargesData",
    "remarks",
    "totalSalePrice",
    "totalItems",
    "totalQty",
    "subtotal",
    "searchedProductsData",
    "reverseOrderData",
    "disableSearch",
    "quantityInputValue",
    "isStockModal",
    "tareWeight",
    "totalWeight",
    "expiryDate",
    "copies",
  ];
  keysToRemove.forEach((key) => localStorage.removeItem(key));
};
